/**
 * Environment configuration utility
 * Centralizes all environment variable access and provides fallbacks
 */

interface EnvConfig {
  apiBaseUrl: string;
  nodeEnv: string;
  appTitle: string;
  appVersion: string;
  isDevelopment: boolean;
  isProduction: boolean;
}

/**
 * Get environment configuration with fallbacks
 */
export function getEnvConfig(): EnvConfig {
  const apiBaseUrl = import.meta.env.VITE_FORMLY_API_BASE_URL;
  const nodeEnv = import.meta.env.VITE_NODE_ENV || "development";
  const appTitle = import.meta.env.VITE_APP_TITLE || "Formly Admin";
  const appVersion = import.meta.env.VITE_APP_VERSION || "1.0.0";

  return {
    apiBaseUrl,
    nodeEnv,
    appTitle,
    appVersion,
    isDevelopment: nodeEnv === "development",
    isProduction: nodeEnv === "production",
  };
}

/**
 * Validate that required environment variables are present
 */
export function validateEnvConfig(): void {
  const config = getEnvConfig();

  if (!config.apiBaseUrl) {
    console.warn("VITE_FORMLY_API_BASE_URL is not set, using default");
  }

  if (config.isDevelopment) {
    console.log("🔧 Development environment detected");
    console.log("📡 API Base URL:", config.apiBaseUrl);
  }
}

// Export the config as a singleton
export const envConfig = getEnvConfig();

// Validate on import
validateEnvConfig();
